import React, {useContext} from 'react';
import VerificationCentersListPageTemplate
    from "../../../../components/Templates/VerificationCentersListPageTemplate";
import LinkCell3 from "../../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import IconCell from "../../../../components/Pages/TablePage/Table/Cells/NewCells/IconCell/IconCell";
import {AuthContext} from "../../../../context/AuthContext";
import {AddOrganizationByRoleId} from "../../../../components/Modals/addOrganizationByRoleId";

function VerificationCenters(props) {
    const {token} = useContext(AuthContext)
    const breadCrumbsItems = [
        {title: 'Контрагенты'},
        {title: 'Удостоверяющие центры', actual: true},
    ]
    const {REACT_APP_URL_PREFIX} = process.env

    const linkCell = props => {
        const url = REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters/${props.idArr[0]}/${props.cellContent}/all`
        return <LinkCell3 linkRoute={url} linkTitle={props.cellContent}
                          editClick={_ => props.cellData.onClick(props.idArr[0])}/>
    }
    const linkCellToCalndar = props => {
        return <IconCell iconName={'calendar'}
                         to={REACT_APP_URL_PREFIX + `/calendar/${props.idArr[0]}/${props.cellContent}`}/>
    }
    const linkCellToPrices = props => {
        return <IconCell iconName={'pencil'}
                         to={REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters/${props.idArr[0]}/${props.cellContent}/prices`}/>
    }
    const linkCellToDoctors = props => {
        return <IconCell iconName={'pencil'}
                         to={REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters/${props.idArr[0]}/${props.cellContent}/doctors`}/>
    }
    const linkCellToMachines = props => {
        return <IconCell iconName={'pencil'}
                         to={REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters/${props.idArr[0]}/${props.cellContent}/machines`}/>
    }

    tableModel.haveToShow[0].typeData.cell = linkCell
    tableModel.haveToShow[1].typeData.cell = linkCellToCalndar
    tableModel.haveToShow[5].typeData.cell = linkCellToPrices
    tableModel.haveToShow[6].typeData.cell = linkCellToDoctors
    tableModel.haveToShow[7].typeData.cell = linkCellToMachines

    return (
        <VerificationCentersListPageTemplate
            getOrgListAPI={`/api/v2/systemManagers/2/verificationCenters?`}
            breadCrumbsItems={breadCrumbsItems}
            tableModel={tableModel}
            addOrgAPI={AddOrganizationByRoleId(5, token.userId).api}
            editOrgAPI={'/api/v1/systemManager/2/verificationCenters'}
            roleIs={5}
        />
    );
}

export default VerificationCenters

var tableModel = {
    firstRow: [
        {title: 'Название', id: 'name',},
        {title: 'Календарь', id: '',},
        {title: 'Количество людей', id: '',},  // Сортировка не добавлена
        {title: 'Количество организаций', id: '',},  // Сортировка не добавлена
        {title: 'Вызов', id: '',},
        {title: 'Цены', id: '',},
        {title: 'Доктора', id: '',},
        {title: 'Машины', id: '',},
    ],
    haveToShow: [
        {id: 'name', idArr: ['id'], type: 'wrapperCell', typeData: {cell: () => {}}},
        {id: 'name', type: 'wrapperCell', idArr: ['verification_id'], typeData: {cell: () => {}}},
        {id: 'patients_count'},
        {id: 'organizationsCount'},
        {id: 'invite_count'},
        {id: 'name', type: 'wrapperCell', idArr: ['verification_id'], typeData: {cell: () => {}}},
        {id: 'name', type: 'wrapperCell', idArr: ['verification_id'], typeData: {cell: () => {}}},
        {id: 'name', type: 'wrapperCell', idArr: ['verification_id'], typeData: {cell: () => {}}},
    ],
}


